/**
 * Decode HTML entities
 */
export function decodeHTMLEntities(html: string): string {
  const txt = document.createElement('textarea');
  txt.innerHTML = html.replace(/&nbsp;/g, ' ');

  return txt.value;
}
